import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import store from './states/store';
import App from './App';
import { TOKEN } from 'constants/cookies';
import { DASHBOARD } from 'routers/route-path';
import Cookies from 'js-cookie';

import 'antd/dist/antd.css';
import 'assets/css/global.scss';
import 'assets/css/core/helper.css';
import 'assets/css/datepicker.scss';
import TagManager from 'react-gtm-module';

import { GoogleOAuthProvider } from '@react-oauth/google';
import domainManagementService from './services/domainManagementService';

// Initialize domain management before app render
domainManagementService.initializeDomain();

const hostname = domainManagementService.getHostnameFromBrandKey();

const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get('token');
if (token) {
  Cookies.set(TOKEN, token);
  Cookies.set(TOKEN, token, {
    domain: `.${hostname}`,
  });
  window.location.href = `${window.location.origin}${DASHBOARD}`;
}

const clientId = process.env.REACT_APP_GG_CLIENT_ID;

// Get tenant-specific GTM ID
const gtmId = domainManagementService.getGtmIdFromBrandKey(domainManagementService.currentDomain);

if (gtmId) {
  const tagManagerArgs = {
    gtmId: gtmId,
  };

  TagManager.initialize(tagManagerArgs);
}

ReactDOM.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={clientId}>
      <App />
    </GoogleOAuthProvider>
  </Provider>,
  document.getElementById('turnitblue-content')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
